// extracted by mini-css-extract-plugin
export default {"main":"app_main__7lx0T","background":"app_background__h6zX1"};